




















import { Vue, Component, Prop } from "vue-property-decorator";
import { Passport as IPassport } from "@/api-v2/student-document-info/models/passport";
import CField from "@/components/form/CField.vue";
@Component({
  components: { CField }
})
export default class StudentDocInfoPassport extends Vue {
  @Prop() passport?: IPassport;

  form: IPassport = {
    issuedBy: "",
    whenIssued: "",
    series: "",
    number: ""
  };

  get docInfoPassport(): IPassport | undefined {
    const isHasValues = Object.values(this.form).some(item => item);
    return isHasValues ? this.form : undefined;
  }

  created() {
    this.form = this.passport ?? this.form;
  }
}
